import { Tooltip } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import { withStyles } from '@material-ui/core/styles'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AddIcon from '@material-ui/icons/Add'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import BarChartIcon from '@material-ui/icons/BarChart'
import Brightness4Icon from '@material-ui/icons/Brightness4'
import BusinessIcon from '@material-ui/icons/Business'
import CheckIcon from '@material-ui/icons/Check'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ReceiptIcon from '@material-ui/icons/Receipt';
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import HomeIcon from '@material-ui/icons/Home'
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid'
import SettingsIcon from '@material-ui/icons/Settings'
import TranslateIcon from '@material-ui/icons/Translate'
import ViewListIcon from '@material-ui/icons/ViewList'
import cn from 'classnames'
import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { withRouter, useHistory } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'
import { AUTH_SERVICE_ROLE_SUPER_ADMIN } from '../../Constants/Auth/Auth.constants'
import { USER_MENU_LANGUAGE, USER_MENU_MAIN, USER_MENU_THEME } from '../../Constants/User/User.constants'
import withEntries from '../../Contexts/Entries/WithEntries.context'
import withServices from '../../Contexts/Services/WithServices.context'
import { ENTRY_PORTAL_CUSTOMER_NAME } from '../../Entries/PortalCustomer/PortalCustomer.entry.constants'
import { createAccountsPageLink } from '../../Pages/Accounts/Accounts.page.route'
import { createAdminPageLink } from '../../Pages/Admin/Admin.page.route'
import { createDashboardPageLink } from '../../Pages/Dashboard/Dashboard.page.route'
import { createDocketsPageLink } from '../../Pages/Dockets/Dockets.page.route'
import { createLogoutPageLink } from '../../Pages/Logout/Logout.page.route'
import { createOrdersPageLink } from '../../Pages/Orders/Orders.page.route'
import { createPlaceOrderPageLink, isPlaceOrderPage } from '../../Pages/PlaceOrder/PlaceOrder.page.route'
import { createProfilePageLink } from '../../Pages/Profile/Profile.page.route'
import { createReportsPageLink } from '../../Pages/Reports/Reports.page.route'
import { createSettingsPageLink } from '../../Pages/Settings/Settings.page.route'
import { createTermsPageLink } from '../../Pages/Terms/Terms.page.route'
import authCurrentSelector from '../../State/Store/Auth/Selectors/AuthCurrent.selector'
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector'
import i18nLocalesSelector from '../../State/Store/I18n/Selectors/I18nLocales.selector'
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions'
import themePaletteTypeSelector from '../../State/Store/Theme/Selectors/ThemePaletteType.selector'
import themeActionCreators from '../../State/Store/Theme/Theme.actions'
import userProfileCurrentSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector'
import updateUserProfileActionCreators from '../../State/Store/UserProfile/UserProfile.actions'
import envGet from '../../Support/Env/Get/EnvGet.support'
import i18nIsLtr from '../../Support/I18n/IsLtr/I18nIsLtr.support'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import themeIsDark from '../../Support/Theme/IsDark/ThemeIsDark.support'
import I18n from '../I18n/I18n.component'
import ProfilePic from '../ProfilePic/ProfilePic.component'
import './UserMenu.component.i18n'
import userMenuStyles from './UserMenu.component.styles'
import NotificationActionCreatorsMapping from 'State/Store/Notification/NotificationActionCreatorCenter'
import Icons from '../Icons/Icons.component'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'

const BoralIcons = Icons as any

const FEATURE_TOGGLE_PROFILE = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_PROFILE` }) === `true`
const FEATURE_TOGGLE_ACCOUNTS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_ACCOUNTS` }) === `true`

interface Props {
  showAvatar?: boolean,
}
interface InjectedProps {
  width: any,
  actions: any,
  services: any,
  entry: any,
  classes: any,
  auth: any,
  match: any,
  locale: any,
  locales: any,
  paletteType: any,
  theme: any,
  userProfile: any,
}
const UserMenuComponent = (props: Props & InjectedProps) => {
  const {
    showAvatar = true,

    width,
    actions,
    services,
    entry,
    classes,
    auth,
    match,
    locale,
    locales,
    paletteType,
    theme,
    userProfile,
  } = props
  const history = useHistory()
  const dispath = useDispatch()
  const { Userback } = (window as any)
  // const { actions, auth, classes, match, locale, paletteType, showAvatar, theme, userProfile, width, history } = this.props
  const [ showPlaceOrder, setShowPlaceOrder] = useState(!!isWidthDown(`sm`, width))
  const [ userMenuAnchor, setUserMenuAnchor ] = useState<any>(null)
  const [ userMenuType, setUserMenuType ] = useState<any>('main')

  const handleDarkModeToggle = () => {
    actions.themeTogglePaletteType()
  }

  const handleLocaleChange = (lang: any) => () => {
    actions.i18nSetLocale({ lang })
    // Here we close and reopen the menu to allow the menu to reposition when transition from a `ltr`, to a `rtl` locale or vicer-versa
    handleUserMenuClose()
    setTimeout(() => {
      handleUserMenuOpen({ currentTarget: userMenuAnchor })
    }, 1)
  }

  const handleUserMenuChange = (userMenuType: any) => () => {
    setUserMenuType(userMenuType)
  }

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null)
  }

  const handleUserMenuOpen = (event: any) => {
    setUserMenuAnchor(event.currentTarget)
  }

  /**
   * Determine whether or not to show the ad,om menu.
   * @returns {boolean} Whether or not to show the menu.
   */
  const shouldRenderAdminMenuItems = () => {
    if (!services.authService.hasRole(AUTH_SERVICE_ROLE_SUPER_ADMIN)) {
      return false
    }
    return true
  }

  /**
   * Determine whether or not to show the dark theme menu.
   * @returns {boolean} Whether or not to show the menu.
   */
  const shouldRenderDarkThemeMenu = () => {
    if (entry.name === ENTRY_PORTAL_CUSTOMER_NAME) {
      return false
    }
    return true
  }

  /**
   * Determine whether or not to show the extra menu items.
   * @returns {boolean} Whether or not to show the extras menu items.
   */
  const shouldRenderExtrasMenuItems = () => {
    return shouldRenderDarkThemeMenu() || shouldRenderLanguageMenu() || shouldRenderSettingsMenu()
  }

  /**
   * Determine whether or not to show the language menu.
   * @returns {boolean} Whether or not to show the menu.
   */
  const shouldRenderLanguageMenu = () => {
    if (entry.name === ENTRY_PORTAL_CUSTOMER_NAME) {
      return false
    }
    return true
  }

  /**
   * Determine whether or not to show the privacy policy menu item.
   * @returns {boolean} Whether or not to show the menu.
   */
  const shouldRenderPrivacyPolicy = () => {
    if (entry.name !== ENTRY_PORTAL_CUSTOMER_NAME) {
      return false
    }
    return true
  }

  /**
   * Determine whether or not to show the settings menu.
   * @returns {boolean} Whether or not to show the menu.
   */
  const shouldRenderSettingsMenu = () => {
    if (entry.name === ENTRY_PORTAL_CUSTOMER_NAME) {
      return false
    }
    return true
  }

  /**
   * Open email client
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const openEmailFeedback = () => {
    window.open("mailto:boralconnects@boral.com.au")
  }

  const renderHeading = () => {
    return (
      <React.Fragment>
        <div className={classes.toolbar}>
          <Grid alignItems="center" className={classes.branding} container>
            <Grid item>
              <img alt={entry.name} className={classes.logo} src={entry.logoLargeUrl} />
            </Grid>
            <Grid item>
              <I18n data={{ name: entry.name }} variant="h6">
                UserMenu.Heading
              </I18n>
            </Grid>
          </Grid>
        </div>
        <Divider />
      </React.Fragment>
    )
  }

  /**
   * This is the main user menu
   * @returns {React.Component} The main user menu
   */
  const renderUserMenuMain = () => {
    const { user } = auth || {}
    const { email, firstName, lastName } = userProfile || {}
    function openFeedback() {
      throw new Error('Function not implemented.')
    }

    return (
      user && (
        <React.Fragment>
          <List>
            <ListItem>
              <Grid container justify="space-between">
                {showAvatar && (
                  <Grid item>
                    <ListItemAvatar>
                      <ProfilePic user={user} />
                    </ListItemAvatar>
                  </Grid>
                )}
                <Grid className={classes.overflowAuto} item>
                  <ListItemText
                    secondary={
                      <Typography noWrap variant="caption" data-mf-replace-inner={MFSDR} className={classes.leftNavEmail}>
                        {email}
                      </Typography>
                    }
                  >
                    <Typography className={cn(classes.username)} noWrap variant="h6" data-mf-replace-inner={MFSDR}>
                      {firstName} {lastName}
                    </Typography>
                  </ListItemText>
                </Grid>
              </Grid>
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button
              onClick={() => history.push({ pathname: createDashboardPageLink() })}
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography className={classes.opacity075} variant="body1">
                  Home
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => history.push({ pathname: createOrdersPageLink() })}
              onMouseEnter={() => setShowPlaceOrder(true)}
              onMouseLeave={() => setShowPlaceOrder(!!isWidthDown(`sm`, width))}
            >
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography className={classes.opacity075} variant="body1">
                  <I18n>UserMenu.ListItem.Orders</I18n>
                </Typography>
                {showPlaceOrder && !isPlaceOrderPage(match) ? (
                  <Tooltip placement="right" title="Place An Order" classes={{ popper: classes.addOrderIcon }}>
                    <IconButton
                      className={classes.placeOrderIcon}
                      onClick={(e) => {
                        history.push({
                          pathname: createPlaceOrderPageLink(),
                        })
                        // e.preventDefault()
                        e.stopPropagation()
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
              </ListItemText>
            </ListItem>
            <ListItem button
              onClick={() => history.push({ pathname: createDocketsPageLink() })}
            >
              <ListItemIcon>
                <ReceiptIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography className={classes.opacity075} variant="body1">
                  <I18n>UserMenu.ListItem.Dockets</I18n>
                </Typography>
              </ListItemText>
            </ListItem>
            {FEATURE_TOGGLE_ACCOUNTS && (
              <ListItem button
                onClick={() => history.push({ pathname: createAccountsPageLink() })}
              >
                <ListItemIcon>
                  <BusinessIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography className={classes.opacity075} variant="body1">
                    <I18n>UserMenu.ListItem.Accounts</I18n>
                  </Typography>
                </ListItemText>
              </ListItem>
            )}
            <ListItem button
              onClick={() => history.push({ pathname: createReportsPageLink() })}
            >
              <ListItemIcon>
                <BarChartIcon />
              </ListItemIcon>
              <ListItemText>
                {` `}
                <Typography className={classes.opacity075} variant="body1">
                  Reports
                </Typography>
              </ListItemText>
            </ListItem>
            {FEATURE_TOGGLE_PROFILE && (
              <ListItem button
                onClick={() => history.push({ pathname: createProfilePageLink() })}
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography className={classes.opacity075} variant="body1">
                    {` `}
                    <I18n>UserMenu.ListItem.Profile</I18n>
                  </Typography>
                </ListItemText>
              </ListItem>
            )}
            <ListItem button
              onClick={() => {
                // actions.updateUserProfile({ profile: null })
                dispath(NotificationActionCreatorsMapping.closeNotificationModal())
                history.push({ pathname: createLogoutPageLink() })
              }}
            >
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography className={classes.opacity075} variant="body1">
                  { `Logout` }
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
          <Divider />
          <ListItem
            button
            onClick={() => {
              openEmailFeedback()
              if (isWidthDown(`md`, width)) {
                actions.sidebarClose()
              }
            }}
          >
            <ListItemIcon>
              <PhoneAndroidIcon color="primary" />
            </ListItemIcon>
            <ListItemText>
              <Typography className={classes.appFeedback} variant="body1">
                App Feedback
              </Typography>
            </ListItemText>
          </ListItem>
          <Divider />
          {shouldRenderAdminMenuItems() && (
            <ListItem button
              onClick={() => history.push({ pathname: createAdminPageLink() })}
            >
              <ListItemText>
                <I18n>UserMenu.ListItem.Admin</I18n>
              </ListItemText>
            </ListItem>
          )}
          {shouldRenderAdminMenuItems() && <Divider />}
          {shouldRenderAdminMenuItems() && (
            <List>
              <ListItem button
                onClick={() => history.push({ pathname: '/layout-template-1' })}
              >
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText>Template 1 (Single Column)</ListItemText>
              </ListItem>
              <ListItem button
                onClick={() => history.push({ pathname: '/layout-template-2' })}
              >
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText>Template 2 (Two Columns)</ListItemText>
              </ListItem>
              <ListItem button
                onClick={() => history.push({ pathname: '/layout-template-3' })}
              >
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText>Template 3 (Large Header)</ListItemText>
              </ListItem>
            </List>
          )}
          {shouldRenderAdminMenuItems() && <Divider />}
          <List>
            <ListItem button
              onClick={() => history.push({ pathname: createTermsPageLink() })}
            >
              <ListItemText>
                <Typography className={classes.opacity075} variant="body2">
                  <I18n>UserMenu.ListItem.Terms</I18n>
                </Typography>
              </ListItemText>
            </ListItem>
            {shouldRenderPrivacyPolicy() && (
              <ListItem button
                onClick={() => window.open('//www.boral.com.au/privacy-policy', '_blank')}
              >
                <ListItemText>
                  <Typography className={classes.opacity075} variant="body2">
                    <I18n>UserMenu.ListItem.Policy</I18n>
                  </Typography>
                </ListItemText>
              </ListItem>
            )}
          </List>
          {shouldRenderExtrasMenuItems() && <Divider />}
          {shouldRenderExtrasMenuItems() && (
            <List>
              {shouldRenderDarkThemeMenu() && (
                <ListItem aria-label="colour-mode-menuitem" button onClick={handleUserMenuChange(USER_MENU_THEME)}>
                  <ListItemIcon>
                    <Brightness4Icon />
                  </ListItemIcon>
                  <ListItemText>
                    <I18n>{themeIsDark(paletteType) ? `UserMenu.UserMenuTheme.DarkThemeOn` : `UserMenu.UserMenuTheme.DarkThemeOff`}</I18n>
                  </ListItemText>
                  <ListItemSecondaryAction className={cn(classes.secondaryAction)}>
                    {i18nIsLtr(theme.direction) ? <ChevronRightIcon color="inherit" /> : <ChevronLeftIcon color="inherit" />}
                  </ListItemSecondaryAction>
                </ListItem>
              )}
              {shouldRenderLanguageMenu() && (
                <ListItem button onClick={handleUserMenuChange(USER_MENU_LANGUAGE)}>
                  <ListItemIcon>
                    <TranslateIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <I18n>UserMenu.ListItem.Language</I18n>: {locale.shortLabel}
                  </ListItemText>
                  <ListItemSecondaryAction className={cn(classes.secondaryAction)}>
                    {i18nIsLtr(theme.direction) ? <ChevronRightIcon color="inherit" /> : <ChevronLeftIcon color="inherit" />}
                  </ListItemSecondaryAction>
                </ListItem>
              )}
              {shouldRenderSettingsMenu() && (
                <ListItem button
                  onClick={() => history.push({ pathname: createSettingsPageLink() })}
                >
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <I18n>UserMenu.ListItem.Settings</I18n>
                  </ListItemText>
                </ListItem>
              )}
            </List>
          )}
        </React.Fragment>
      )
    )
  }

  const renderUserMenuLanguage = () => {
    // const { classes, locale, locales } = this.props
    return (
      <React.Fragment>
        <List>
          <ListItem onClick={handleUserMenuChange(USER_MENU_MAIN)}>
            <ListItemIcon>
              <ArrowBackIcon />
            </ListItemIcon>
            <ListItemText>
              <I18n>UserMenu.UserMenuLanguage.Heading</I18n>
            </ListItemText>
          </ListItem>
        </List>
        <List>
          {/* menu language is not in use and currently there are no plans to use it. ListItem below triggers Typescript compile errors so is commented for now. If there ever is the need to use menu language menu, uncomment below
          {locales.map(({ direction, label, lang }: any) => (
            <ListItem key={lang} {...(lang === locale.lang ? {} : { button: true, onClick: handleLocaleChange(lang) })}>
              <ListItemIcon>{lang === locale.lang ? <CheckIcon /> : <div className={cn(classes.iconSmall)} />}</ListItemIcon>
              <ListItemText>
                <Typography className={cn(classes.mutedText)} style={{ direction }} variant="button">
                  {label}
                </Typography>
              </ListItemText>
            </ListItem>
          ))} */}
        </List>
      </React.Fragment>
    )
  }

  /**
   * This is the theme user menu
   * @returns {React.Component} The theme user menu
   */
  const renderUserMenuTheme = () => {
    // const { classes, paletteType } = this.props
    return (
      <React.Fragment>
        <List>
          <ListItem onClick={handleUserMenuChange(USER_MENU_MAIN)}>
            <ListItemIcon>
              <ArrowBackIcon />
            </ListItemIcon>
            <ListItemText>
              <I18n>UserMenu.UserMenuTheme.Heading</I18n>
            </ListItemText>
          </ListItem>
        </List>
        <List>
          <ListItem>
            <ListItemText>
              <I18n>UserMenu.UserMenuTheme.Description</I18n>
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <I18n>UserMenu.UserMenuTheme.Disclaimer</I18n>
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <I18n className={cn(classes.mutedText)} variant="button">
                UserMenu.UserMenuTheme.Heading
              </I18n>
            </ListItemText>
            <ListItemSecondaryAction>
              <Switch aria-label="colour-mode-switch" checked={themeIsDark(paletteType)} onChange={handleDarkModeToggle} value={USER_MENU_THEME} />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </React.Fragment>
    )
  }

  /**
   * Render the user menu
   * @returns {React.Component} The user menu
   */
  const renderUserMenu = () => {
    // const { classes } = this.props
    // const { userMenuType } = this.state
    return (
      <div className={cn(classes.userMenu, classes.menuWidth)}>
        {renderHeading()}
        {userMenuType === USER_MENU_MAIN && renderUserMenuMain()}
        {userMenuType === USER_MENU_LANGUAGE && renderUserMenuLanguage()}
        {userMenuType === USER_MENU_THEME && renderUserMenuTheme()}
      </div>
    )
  }

  return renderUserMenu()
}

/** @type {React.ComponentClass<UserMenuComponentProps>} */
const UserMenu = compose(
  withEntries,
  withRouter,
  withServices,
  withWidth(),
  withStyles(themeCreateInjectableStyles(userMenuStyles) as any, { withTheme: true }),
  connect(
    (state: any) => ({
      auth: authCurrentSelector(state),
      userProfile: userProfileCurrentSelector(state),
      locale: i18nLocaleSelector(state),
      locales: i18nLocalesSelector(state),
      paletteType: themePaletteTypeSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...themeActionCreators,
          ...sidebarActionCreators,
          ...updateUserProfileActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(UserMenuComponent)

export default UserMenu
